import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import Maybe from 'graphql/tsutils/Maybe';

const PATIENT_NAME = gql`
  query patientName {
    patientName: patient {
      id
      first: firstName
      last: lastName
    }
  }
`;

interface PatientName {
  id: string;
  first: string;
  last: string;
}

export function usePatientName(): Maybe<PatientName> {
  const { data, loading } = useQuery<{ patientName: PatientName }>(PATIENT_NAME);
  if (!data || loading) return null;
  return data.patientName;
}
